// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;


		// masking the background when searching
		// if (searchElement.first().hasClass("target")) {
		// 	$('#content').first().addClass('no-visibility');
		// 	$('#store-messages-mobile').first().addClass('no-visibility');
		// 	$('#pagefooter').first().addClass('no-visibility');
		// }

		// searchElement.first().on('input', function() {
		// 	if ($(this).first().val() == '') {
		// 		$('#content').first().removeClass('no-visibility');
		// 		$('#store-messages-mobile').first().removeClass('no-visibility');
		// 		$('#pagefooter').first().removeClass('no-visibility');
		// 	}
		// })
        
	};
})();